import { useState } from 'react';

export function useAlert() {
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const showAlert = (type, message, duration = 5000) => {
    setAlert({ show: true, type, message });
    if (duration > 0) {
      setTimeout(() => {
        setAlert({ show: false, type: '', message: '' });
      }, duration);
    }
  };

  const hideAlert = () => {
    setAlert({ show: false, type: '', message: '' });
  };

  return { alert, showAlert, hideAlert };
}
